import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../core/api/rsaa';
import { Endpoints } from '../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../core/api/module';


const KEY_ACTION = ActionType.SecurityQuestionRequest;
const ACTIONS    = [
  ActionType.SecurityQuestionRequest,
  ActionType.SecurityQuestionResponse,
  ActionType.SecurityQuestionError,
];

type Payload = {
  securityQuestionId: number;
  securityAnswer: string;
};

type Meta = {
  emailAddress: string;
}

/**
 * Dispatch this action to retrieve the user's security question (which they will have to answer in order to reset
 * their password)
 * @param emailAddress - the email address of the user whose security question we need to retrieve
 */
export const securityQuestionAction = (emailAddress: string) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.GetSecurityQuestion,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({ email: emailAddress }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { emailAddress: emailAddress }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['auth', 'passwordReset'], payload, successState);
};


export const securityQuestionReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
